import type { Ticket } from '@shared/schemas'
import type { PageProps, QueryDefinition } from '@/core'
import type { TicketsFormValues } from './form'
import type { TicketsVariables } from './variables'

export const TICKET_KEYS = {
  all: ['tickets'] as const,
  lists: () => [...TICKET_KEYS.all, 'list'].join('/'),
  detail: (id: string) => [...TICKET_KEYS.all, 'detail', id].join('/'),
}

export type TicketsQueryDefinition = [
  QueryDefinition<
    'tickets',
    'query',
    Record<string, unknown> | void,
    { data: Array<Ticket>; total: number }
  >,
]

export const ticketsQueries: NonNullable<
  PageProps<
    TicketsFormValues,
    TicketsQueryDefinition,
    TicketsVariables
  >['queries']
> = [
  {
    key: 'tickets',
    type: 'query',
    queryConfig: {
      queryKey: [TICKET_KEYS.lists()],
      endpoint: ['api', 'tickets'],
      enabled: true,
    },
  },
]
